import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=1820c062&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1820c062"]])

export default __exports__